/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gender__M1Inputs */

const en_gender__m1 = /** @type {(inputs: Gender__M1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Male`)
};

/**
* | output |
* | --- |
* | "Male" |
*
* @param {Gender__M1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const gender__m1 = /** @type {((inputs?: Gender__M1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gender__M1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_gender__m1(inputs)
});
export { gender__m1 as "gender__M" }